import React, { useEffect, useState } from "react";
import { ChevronUp } from "lucide-react";

/**
 * Floating "back to top" button — appears when scrolled > threshold.
 * Positioned above the ChatWidget FAB.
 */
export default function BackToTop({ threshold = 500 }) {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > threshold);
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
        return () => window.removeEventListener("scroll", onScroll);
    }, [threshold]);

    if (!visible) return null;

    return (
        <button
            type="button"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="bc-backtotop"
            aria-label="Retour en haut"
            data-testid="back-to-top"
        >
            <ChevronUp size={18} strokeWidth={2.4} />
        </button>
    );
}
